/**
 * description:
 * dateTime: 2024/8/20-上午9:37
 * author: ZhangJun 1580043700@qq.com
 */
import {Button, Dropdown, Flex, Form, Input, Result, Spin, Tree, TreeSelect, Typography} from 'antd'
import {ApartmentOutlined} from '@ant-design/icons'
import {SFuncModal, SMessage} from 'shj-components'
import {useEffect, useMemo, useState} from 'react'

type ChangeType = 'add' | 'edit'

type TreeMenuProps = {
    value: any
    loading?: boolean
    treeData: Array<any>
    fieldNames?: any
    addDisabled?: (node: any) => boolean
    onClick?: (keys: Array<any>, item: any) => void
    onEditChange?: ({type, values}: { type: ChangeType; values: any }) => Promise<any>
}

function TreeMenu(props: TreeMenuProps) {
    const {fieldNames = {title: 'title', key: 'key', children: 'children'}} = props
    const [loading, setLoading] = useState(false)

    const items = (disabled: boolean) => [
        {
            key: 'add',
            label: '添加下级',
            disabled: disabled,
        },
        {
            key: 'edit',
            label: '编辑分类',
        },
        {
            key: 'delete',
            label: '删除分类',
        },
    ]


    const onOpenChange = async (info: any, nodeData: any) => {

        if (info.key == 'delete') {
            SMessage.confirm({
                title: '删除分类',
                content: `确定删除"${nodeData[fieldNames.title]}"分类吗？`,
                onOk: async () => {
                    setLoading(true)
                    try {
                        await props.onEditChange?.({type: info.key, values: nodeData})
                    } catch (e) {
                        console.log(e)
                    }
                    setLoading(false)
                }
            })
        } else {
            let title = '新增分类'
            let initValues: any = {
                parentId: null,
                name: '',
            }
            if (info.key == 'add' && nodeData != null) {
                title = '新增下级分类'
                initValues = {
                    parentId: nodeData[fieldNames.key],
                    name: '',
                }
            } else if (info.key == 'edit') {
                title = '编辑分类'
                initValues = {
                    parentId: nodeData.parentId == '0' ? null : nodeData.parentId,
                    id: nodeData.id,
                    name: nodeData[fieldNames.title],
                }
            }

            const onOk = async (values: any) => {
                try {
                    setLoading(true)
                    await props.onEditChange?.({type: info.key, values})
                } catch (e) {
                    console.log(e)
                }
                setLoading(false)
                destroy()
            }

            const destroy = () => {
                modal.destroy()
            }
            const modal = SFuncModal({
                title,
                content: (
                    <EditForm
                        onCancel={destroy}
                        initValues={initValues}
                        treeData={props.treeData}
                        fieldNames={fieldNames}
                        onOk={onOk}
                    />
                ),
                vanish: true,
            })
        }
    }

    const onSelect = (_, e) => {
        props.onClick?.(_, e.node)
    }

    return (
        <div
            style={{
                padding: '20px',
                borderRadius: '10px',
                background: '#fff',
                marginRight: '10px',
                width: '300px',
            }}
        >
            <Spin spinning={loading || props.loading}>
                <div style={{marginBottom: '10px'}}>
                </div>
                <div style={{height: '400px', overflow: 'auto'}}>
                    <Tree
                        treeData={props.treeData}
                        blockNode
                        selectedKeys={props.value}
                        defaultExpandAll
                        fieldNames={fieldNames}
                        onSelect={onSelect}
                        titleRender={nodeData => (
                            <Flex justify="space-between">
                                <Typography.Text ellipsis
                                                 style={{maxWidth: '140px'}}>{nodeData[fieldNames.title]}</Typography.Text>
                                <Dropdown
                                    menu={{
                                        items: items(nodeData.level > 4),
                                        onClick: info => onOpenChange(info, nodeData),
                                    }}
                                >
                                    <a>
                                        <ApartmentOutlined/>
                                    </a>
                                </Dropdown>
                            </Flex>
                        )}
                    ></Tree>
                    {props.treeData.length == 0 && <Result title={'暂无数据'} subTitle="添加一条数据吧"/>}
                </div>
                <div style={{marginTop: '10px'}}>
                    <Button
                        style={{width: '100%'}}
                        type="primary"
                        onClick={() => onOpenChange({key: 'add'}, null)}
                    >
                        新增
                    </Button>
                </div>
            </Spin>
        </div>
    )
}

function EditForm(props: any) {
    const {fieldNames} = props
    const {title = 'title', key = 'key', children = 'children'} = fieldNames || {}

    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm()

    const treeData = useMemo(() => props.treeData, [props.treeData])

    const onOk = () => {
        form.validateFields().then(async values => {
            setLoading(true)
            await props.onOk(values)
            setLoading(false)
        })
    }
    useEffect(() => {
        form.resetFields()
        form.setFieldsValue(props.initValues || {})
    }, [props.initValues])

    return (
        <SFuncModal.Content onOk={onOk} onCancel={props.onCancel} confirmLoading={loading}>
            <Form form={form}>
                {(props.initValues || {}).parentId != null && (
                    <Form.Item label="父级分类" name="parentId">
                        <TreeSelect
                            treeData={treeData}
                            disabled
                            fieldNames={{label: title, value: key, children}}
                            treeDefaultExpandAll
                            allowClear
                        />
                    </Form.Item>
                )}
                <Form.Item label="分类名称" name="id" hidden>
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="分类名称"
                    name="name"
                    rules={[{required: true, message: '请输入分类名称'}]}
                >
                    <Input placeholder="请输入分类名称" maxLength={20}/>
                </Form.Item>
            </Form>
        </SFuncModal.Content>
    )
}

export default TreeMenu
